import { DispatcherEvent } from '@carvana/merch-native';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useVehicleDetailsForNative from '~/hooks/vdp/selectors/useVehicleDetailsForNative';
import { navPerformanceNow } from '~/utilities/navigationTiming';
import sendMessageToNative from './sendMessageToNative';

export default function useNativeMessageDispatcher() {
  const { vehicleAvailability } = useContext(UserVehicleContext);
  const payload = useVehicleDetailsForNative();

  useEffectOnce(
    () => {
      sendMessageToNative(DispatcherEvent.PageReady, {
        ...payload,
        navigationToNowMs: navPerformanceNow()
      });
    },
    [payload],
    vehicleAvailability.isLoaded
  );
}
